import { useEffect } from "react";
import { useForm } from "../../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../../controls/Input";
import SelectMenu from "../../../controls/SelectMenu";

import Button from "../../../controls/Button";

const initialFValues = {
  name: "",
};

export default function CategoryDetailsForm(props) {
  const { actionCall, category, classes, isEdit, setOpen, title } = props;

  const { values, setValues, errors, setErrors, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues) {
      temp.name = null;
      if (!String(fieldValues.name ?? "").trim()) {
        temp.name = "This field is required.";
      }
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values) {
      return Object.values(temp).every((x) => x === null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      actionCall(values);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setValues(category);
    }
  }, [category, isEdit, setValues]);

  return (
    <form
      className="flex h-full flex-col bg-card"
      onSubmit={handleSubmit}
    >
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <div className="border-b border-subtle px-4 py-5 sm:px-6">
          <div className="flex items-center justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-brand">
              {title}
            </Dialog.Title>
            <button
              type="button"
              className="inline-flex h-10 w-10 items-center justify-center rounded-md text-slate-500 hover:bg-accent-soft hover:text-brand focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2"
              onClick={() => setOpen({ childComponent: null, open: false })}
            >
              <span className="sr-only">Close panel</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
        <div className="grid gap-5 px-4 py-6 sm:px-6">
          <Input
            label="Name"
            name="name"
            required
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            className="input-brand mt-1"
            error={errors.name}
          />

          <SelectMenu
            handleInputChange={handleInputChange}
            name="class"
            options={classes.filter((option) => option.value !== -1)}
            value={values.class ?? null}
            title="Class"
            error={errors.class}
            showLabel={true}
            placeholder="Select a class"
          />
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end gap-3 border-t border-subtle bg-surface px-4 py-4 sm:px-6">
        <Button
          type="button"
          variant="secondary"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </Button>
        <Button type="submit">{isEdit ? "Save category" : "Create category"}</Button>
      </div>
    </form>
  );
}
